import { makeStyles } from "@mui/styles";
import { createTheme } from '@mui/material/styles';
const theme = createTheme();

const useQuestionsAndOptionsStyle = makeStyles(() => ({
  container: {
    width: "75%",
    margin: "2rem auto",
    [theme.breakpoints.down("xs")]: {
      width: "90%",
      margin: "0rem auto",
    },
  },
  containerInner: {
    margin: "3rem 0",
  },
  heading: {
    display: "flex",
    alignItems: "center",
    background: "#D7DAF2",
    padding: "0.4rem 3rem",
    borderRadius: "6px",
    "& .MuiTypography-h3": {
      color: "#252525",
      fontSize: "1rem",
      fontStyle: "normal",
      fontWeight: "600",
      lineHeight: "2.625rem",
      textTransform: "capitalize",
    },
  },
  notepadIcon: {
    margin: "0 0.5rem",
  },
  quizContainer: {
    background: "#FCFCFC",
    padding: "1rem 2rem ",
  },
  direction: {
    margin: "2rem 0",
  },
  question: {
    "& img": {
      maxWidth: "50%",
    },
    "& .MuiTypography-caption": {
      color: "#727272",
      fontSize: "0.8rem",
      fontStyle: "normal",
      fontWeight: "500",
      lineHeight: "2.625rem",
      textTransform: "capitalize",
    },
    "& .MuiTypography-h6": {
      color: "#252525",
      fontSize: "0.95rem",
      fontStyle: "normal",
      lineHeight: "1.625rem",
      textTransform: "capitalize",
    },
  },
  optionsContainer: {
    margin: "3rem 0",
  },
  options: {
    margin: "1rem 0",
    padding: "0.6rem",
    background: "#FFF",
    display: "flex",
    alignItems: "center",
    borderRadius: "6px",
    boxShadow: "0px 6px 20px 0px rgba(0, 0, 0, 0.06)",
    "& img": {
      maxWidth: "100%",
    },
    "& .MuiTypography-h6": {
      width: "93%",
      color: "#252525",
      fontSize: "0.8rem",
      fontStyle: "normal",
      fontWeight: "600",
      lineHeight: "1.625rem",
      textTransform: "capitalize",
    },
  },
  rightOption: {
    background: "#EEFFF0",
    border: "2px solid #AAFFB2",
  },
  wrongOption: {
    background: "#FFF2F2",
    border: "2px solid #FFC1C1",
  },
  squareBox: {
    width: "28px",
    height: "28px",
    backgroundColor: "rgba(241, 241, 241, 1)",
    fontWeight: "500",
    color: "rgba(33, 33, 33, 1)",
    fontSize: "18px",
    textTransform: "capitalize",
    borderRadius: "4px",
    fontFamily: "'Jost', sans-serif",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  redSquareBox: {
    backgroundColor: "rgba(255, 57, 57, 1)",
    color: "white",
  },
  greenSquareBox: {
    backgroundColor: "rgba(0, 169, 17, 1)",
    color: "white",
  },
  crossIcon: {
    color: "rgba(255, 252, 244, 1)",
    padding: "0.3rem",
    width: "13px",
    height: "13px",
    backgroundColor: "rgba(255, 57, 57, 1)",
    borderRadius: "6px",
  },

  checkIcon: {
    color: "rgba(255, 255, 255, 1)",
    padding: "0.3rem",
    width: "13px",
    height: "13px",
    backgroundColor: "rgba(0, 169, 17, 1)",
    borderRadius: "6px",
  },
}));

export default useQuestionsAndOptionsStyle;
